// src/components/HeaderClock.jsx
// Today's date and the time now, in the person's time zone, in the header's
// user card under their role and account (compact). Plain text since 3.18.0:
// clicking the card opens the user menu (time zone: My profile).
// 3.18.3: ticking seconds mustn't move the card: every number has a fixed
// width (tabular digits, each run in its own box) and the hour is 2-digit.
import { useEffect, useState } from 'react';
import { timeZone, tzLabel, timeZoneName } from '../utils/timeZone';
import Emo from './Emo';

// placeholder: the same text, invisible, holding its space in the card
export default function HeaderClock({ onClick, compact = false, placeholder = false }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const tz = timeZone();
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(now);
  const text = parts.map((p, i) => (/^\d+$/.test(p.value)
    ? <span key={i} style={{ display: 'inline-block', width: `${p.value.length}ch`, textAlign: 'right' }}>{p.value}</span>
    : p.value));
  if (placeholder) return <span aria-hidden="true" style={{ ...S.btn, ...S.compact, display: 'block', visibility: 'hidden', textDecoration: 'none' }}><Emo e="🕒" /> {text} {tzLabel(now)}</span>;
  if (!onClick) return <span style={{ ...S.btn, ...(compact ? S.compact : {}), ...S.text }} title={timeZoneName(tz)}><Emo e="🕒" /> {text} {tzLabel(now)}</span>;
  return (
    <button onClick={onClick} className={compact ? undefined : 'clock-chip'} style={compact ? { ...S.btn, ...S.compact } : { ...S.btn, ...S.chip }} title={`${timeZoneName(tz)}. Click to change your time zone.`}>
      <span className="clock-ico" aria-hidden="true"><Emo e="🕒" /></span> {text} {tzLabel(now)}
    </button>
  );
}

const S = {
  compact: { fontVariantNumeric: 'tabular-nums', padding: 0, fontSize: 12, color: 'var(--t-37474f)', fontWeight: 500 },   // readable in the user card (3.18.1)
  text: { display: 'block', cursor: 'inherit', textDecoration: 'none', lineHeight: 1.3 },
  // 3.22.2: above the menu as a small label of its own (no dotted underline, which broke up around each number)
  chip: { textDecoration: 'none', padding: '3px 10px', borderRadius: 12, background: 'var(--c-ffffff)', border: '1px solid var(--c-e0f2f1)', color: 'var(--t-546e7a)' },
  btn: { fontVariantNumeric: 'tabular-nums', background: 'none', border: 'none', padding: '2px 4px', cursor: 'pointer', color: 'var(--t-607d8b)', fontSize: 12, fontFamily: 'inherit', textDecoration: 'underline dotted', textUnderlineOffset: 3, whiteSpace: 'nowrap' },
};
